var render = function render(){
  var _vm$newer, _vm$newer$data, _vm$newer$data$person, _vm$newer2, _vm$newer2$data, _vm$newer2$data$perso, _vm$newer2$data$perso2, _vm$newer3, _vm$newer3$data, _vm$newer3$data$perso, _vm$newer3$data$perso2, _vm$newer4, _vm$newer4$data, _vm$newer4$data$perso, _vm$newer4$data$perso2, _vm$newer5, _vm$newer5$data, _vm$newer5$data$perso, _vm$newer5$data$perso2, _vm$newer6, _vm$newer6$data, _vm$newer6$data$perso, _vm$newer6$data$perso2, _vm$newer7, _vm$newer7$data, _vm$newer7$data$perso, _vm$newer7$data$perso2, _vm$newer8, _vm$newer8$data, _vm$newer8$data$perso, _vm$newer8$data$perso2, _vm$newer9, _vm$newer9$data, _vm$newer9$data$perso, _vm$newer9$data$perso2, _vm$newer10, _vm$newer10$data, _vm$newer10$data$pers, _vm$newer10$data$pers2, _vm$newer11, _vm$newer11$data, _vm$newer11$data$pers, _vm$newer11$data$pers2, _vm$newer12, _vm$newer12$data, _vm$newer12$data$pers, _vm$newer12$data$pers2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "my-15"
  }, [_vm._v("Informations Personnelles")]), _vm._v(" "), !!((_vm$newer = _vm.newer) !== null && _vm$newer !== void 0 && (_vm$newer$data = _vm$newer.data) !== null && _vm$newer$data !== void 0 && (_vm$newer$data$person = _vm$newer$data.personnal) !== null && _vm$newer$data$person !== void 0 && _vm$newer$data$person.old) ? _c('div', {
    staticClass: "text-pink-600 mb-10 text-center text-sm"
  }, [_vm._v("\n    Certaines données ont été modifiées sur la page Informations Personnelles\n    de votre Neopass, vous pouvez les mettres à jour en cliquant sur l'icone\n    d'horloge situé à côté du champ correspondant.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-8 justify-center gap-y-5"
  }, [_c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "prenom_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).prenom || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).prenom || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "prenom",
      "libelle": "Prénom",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).prenom || {}).value || '',
      "placeholder": "Prénom",
      "error": true,
      "msg-error": ((_vm.errors || []).prenom || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).prenom || {}).value = newValue;
        (_vm.errors || []).prenom = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer2 = _vm.newer) === null || _vm$newer2 === void 0 ? void 0 : (_vm$newer2$data = _vm$newer2.data) === null || _vm$newer2$data === void 0 ? void 0 : (_vm$newer2$data$perso = _vm$newer2$data.personnal) === null || _vm$newer2$data$perso === void 0 ? void 0 : (_vm$newer2$data$perso2 = _vm$newer2$data$perso.prenom) === null || _vm$newer2$data$perso2 === void 0 ? void 0 : _vm$newer2$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.prenom.value = newValue;
        _vm.newer.data.personnal.prenom.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "nom_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).nom || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).nom || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "nom",
      "libelle": "Nom",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).nom || {}).value,
      "placeholder": "Nom",
      "error": true,
      "msg-error": ((_vm.errors || []).nom || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).nom || {}).value = newValue;
        (_vm.errors || []).nom = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer3 = _vm.newer) === null || _vm$newer3 === void 0 ? void 0 : (_vm$newer3$data = _vm$newer3.data) === null || _vm$newer3$data === void 0 ? void 0 : (_vm$newer3$data$perso = _vm$newer3$data.personnal) === null || _vm$newer3$data$perso === void 0 ? void 0 : (_vm$newer3$data$perso2 = _vm$newer3$data$perso.nom) === null || _vm$newer3$data$perso2 === void 0 ? void 0 : _vm$newer3$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.nom.value = newValue;
        _vm.newer.data.personnal.nom.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "date_naissance_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).date_naissance || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).date_naissance || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('date-picker', {
    attrs: {
      "name": "date_naissance",
      "libelle": "Date de naissance",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).date_naissance || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).date_naissance || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).date_naissance || {}).value = newValue;
        (_vm.errors || []).date_naissance = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer4 = _vm.newer) === null || _vm$newer4 === void 0 ? void 0 : (_vm$newer4$data = _vm$newer4.data) === null || _vm$newer4$data === void 0 ? void 0 : (_vm$newer4$data$perso = _vm$newer4$data.personnal) === null || _vm$newer4$data$perso === void 0 ? void 0 : (_vm$newer4$data$perso2 = _vm$newer4$data$perso.date_naissance) === null || _vm$newer4$data$perso2 === void 0 ? void 0 : _vm$newer4$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.date_naissance.value = newValue;
        _vm.newer.data.personnal.date_naissance.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "telephone_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).telephone || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).telephone || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "telephone",
      "libelle": "Téléphone",
      "placeholder": 'Téléphone',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).telephone || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).telephone || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).telephone || {}).value = newValue;
        (_vm.errors || []).telephone = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer5 = _vm.newer) === null || _vm$newer5 === void 0 ? void 0 : (_vm$newer5$data = _vm$newer5.data) === null || _vm$newer5$data === void 0 ? void 0 : (_vm$newer5$data$perso = _vm$newer5$data.personnal) === null || _vm$newer5$data$perso === void 0 ? void 0 : (_vm$newer5$data$perso2 = _vm$newer5$data$perso.telephone) === null || _vm$newer5$data$perso2 === void 0 ? void 0 : _vm$newer5$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.telephone.value = newValue;
        _vm.newer.data.personnal.telephone.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "email_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).email || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).email || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "email",
      "libelle": "Email",
      "placeholder": 'Email',
      "type": "email",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).email || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).email || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).email || {}).value = newValue;
        (_vm.errors || []).email = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer6 = _vm.newer) === null || _vm$newer6 === void 0 ? void 0 : (_vm$newer6$data = _vm$newer6.data) === null || _vm$newer6$data === void 0 ? void 0 : (_vm$newer6$data$perso = _vm$newer6$data.personnal) === null || _vm$newer6$data$perso === void 0 ? void 0 : (_vm$newer6$data$perso2 = _vm$newer6$data$perso.email) === null || _vm$newer6$data$perso2 === void 0 ? void 0 : _vm$newer6$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.email.value = newValue;
        _vm.newer.data.personnal.email.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full flex space-x-3 items-center"
  }, [_c('radio-button', {
    attrs: {
      "name": "adresse_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).adresse || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).adresse || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    attrs: {
      "name": "adresse",
      "libelle": "Adresse complète",
      "placeholder": 'Adresse complète',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).adresse || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).adresse || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).adresse || {}).value = newValue;
        (_vm.errors || []).adresse = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer7 = _vm.newer) === null || _vm$newer7 === void 0 ? void 0 : (_vm$newer7$data = _vm$newer7.data) === null || _vm$newer7$data === void 0 ? void 0 : (_vm$newer7$data$perso = _vm$newer7$data.personnal) === null || _vm$newer7$data$perso === void 0 ? void 0 : (_vm$newer7$data$perso2 = _vm$newer7$data$perso.adresse) === null || _vm$newer7$data$perso2 === void 0 ? void 0 : _vm$newer7$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.adresse.value = newValue;
        _vm.newer.data.personnal.adresse.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full flex space-x-3 items-center"
  }, [_c('radio-button', {
    attrs: {
      "name": "travailleur_handicape",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).travailleur_handicape || {}).value || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).travailleur_handicape || {}).value = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base"
  }, [_vm._v("\n        Reconnaissance en tant que travailleur handicapé\n      ")]), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer8 = _vm.newer) === null || _vm$newer8 === void 0 ? void 0 : (_vm$newer8$data = _vm$newer8.data) === null || _vm$newer8$data === void 0 ? void 0 : (_vm$newer8$data$perso = _vm$newer8$data.personnal) === null || _vm$newer8$data$perso === void 0 ? void 0 : (_vm$newer8$data$perso2 = _vm$newer8$data$perso.travailleur_handicape) === null || _vm$newer8$data$perso2 === void 0 ? void 0 : _vm$newer8$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.travailleur_handicape.value = newValue;
        _vm.newer.data.personnal.travailleur_handicape.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "permis_conduire_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).permis_conduire || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).permis_conduire || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('multiple-select', {
    attrs: {
      "datas": [{
        value: 'ASSR1'
      }, {
        value: 'ASSR2'
      }, {
        value: 'BSR'
      }, {
        value: 'A'
      }, {
        value: 'A1'
      }, {
        value: 'B'
      }, {
        value: 'B1'
      }, {
        value: 'C'
      }, {
        value: 'D'
      }, {
        value: 'E'
      }, {
        value: 'Autres'
      }],
      "name": "permis_conduire",
      "libelle": "Permis de conduire",
      "placeholder": 'Permis de conduire',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).permis_conduire || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).permis_conduire || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).permis_conduire || {}).value = newValue;
        (_vm.errors || []).permis_conduire = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer9 = _vm.newer) === null || _vm$newer9 === void 0 ? void 0 : (_vm$newer9$data = _vm$newer9.data) === null || _vm$newer9$data === void 0 ? void 0 : (_vm$newer9$data$perso = _vm$newer9$data.personnal) === null || _vm$newer9$data$perso === void 0 ? void 0 : (_vm$newer9$data$perso2 = _vm$newer9$data$perso.permis_conduire) === null || _vm$newer9$data$perso2 === void 0 ? void 0 : _vm$newer9$data$perso2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.permis_conduire.value = newValue;
        _vm.newer.data.personnal.permis_conduire.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "moyen_transport_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).moyen_transport || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).moyen_transport || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('multiple-select', {
    attrs: {
      "datas": [{
        value: 'Aucun'
      }, {
        value: 'Voiture'
      }, {
        value: 'Moto'
      }, {
        value: 'Scooter'
      }, {
        value: 'Vélo'
      }, {
        value: 'Marche'
      }, {
        value: 'Train'
      }, {
        value: 'Bus'
      }, {
        value: 'Transports en commun'
      }, {
        value: 'Autres'
      }],
      "name": "moyen_transport",
      "libelle": "Moyen de transport",
      "placeholder": 'Moyen de transport',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).moyen_transport || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).moyen_transport || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).moyen_transport || {}).value = newValue;
        (_vm.errors || []).moyen_transport = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer10 = _vm.newer) === null || _vm$newer10 === void 0 ? void 0 : (_vm$newer10$data = _vm$newer10.data) === null || _vm$newer10$data === void 0 ? void 0 : (_vm$newer10$data$pers = _vm$newer10$data.personnal) === null || _vm$newer10$data$pers === void 0 ? void 0 : (_vm$newer10$data$pers2 = _vm$newer10$data$pers.moyen_transport) === null || _vm$newer10$data$pers2 === void 0 ? void 0 : _vm$newer10$data$pers2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.moyen_transport.value = newValue;
        _vm.newer.data.personnal.moyen_transport.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "site_web_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).site_web || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).site_web || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "site_web",
      "libelle": "Site internet personnel",
      "placeholder": 'Site internet personnel',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).site_web || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).site_web || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).site_web || {}).value = newValue;
        (_vm.errors || []).site_web = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer11 = _vm.newer) === null || _vm$newer11 === void 0 ? void 0 : (_vm$newer11$data = _vm$newer11.data) === null || _vm$newer11$data === void 0 ? void 0 : (_vm$newer11$data$pers = _vm$newer11$data.personnal) === null || _vm$newer11$data$pers === void 0 ? void 0 : (_vm$newer11$data$pers2 = _vm$newer11$data$pers.site_web) === null || _vm$newer11$data$pers2 === void 0 ? void 0 : _vm$newer11$data$pers2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.site_web.value = newValue;
        _vm.newer.data.personnal.site_web.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3 items-center"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "linkedin_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).linkedin || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).linkedin || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "linkedin",
      "libelle": "Linkedin",
      "placeholder": 'Linkedin',
      "value": ((((_vm.form || {}).data || {}).personnal || {}).linkedin || {}).value,
      "error": true,
      "msg-error": ((_vm.errors || []).linkedin || [])[0]
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).linkedin || {}).value = newValue;
        (_vm.errors || []).linkedin = [];
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('CVNewValue', {
    staticClass: "pt-6",
    attrs: {
      "old": (_vm$newer12 = _vm.newer) === null || _vm$newer12 === void 0 ? void 0 : (_vm$newer12$data = _vm$newer12.data) === null || _vm$newer12$data === void 0 ? void 0 : (_vm$newer12$data$pers = _vm$newer12$data.personnal) === null || _vm$newer12$data$pers === void 0 ? void 0 : (_vm$newer12$data$pers2 = _vm$newer12$data$pers.linkedin) === null || _vm$newer12$data$pers2 === void 0 ? void 0 : _vm$newer12$data$pers2.old
    },
    on: {
      "change": function (newValue) {
        _vm.form.data.personnal.linkedin.value = newValue;
        _vm.newer.data.personnal.linkedin.old = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full md:col-span-1 flex space-x-3"
  }, [_c('radio-button', {
    staticClass: "pt-5",
    attrs: {
      "name": "profile_image_display",
      "value": ((((_vm.form || {}).data || {}).personnal || {}).profile_image || {}).isDisplayed || false
    },
    on: {
      "input": function (newValue) {
        ((((_vm.form || {}).data || {}).personnal || {}).profile_image || {}).isDisplayed = newValue;
      },
      "loseFocus": function ($event) {
        return _vm.saveDatas();
      }
    }
  }), _vm._v(" "), _c('profile-picture', {
    attrs: {
      "id": "photo",
      "size": "max-w-28 w-28 h-28",
      "is-circle-avatar": false,
      "specific-url": ((((_vm.form || {}).data || {}).personnal || {}).profile_image || {}).value || null,
      "specific-rounded": "rounded-xl",
      "specific-media": "cv-profile-picture",
      "show-edit-link": true,
      "type-profile-picture": "cv",
      "other-object": _vm.form,
      "with-border": true
    },
    on: {
      "changeProfileImageToAnotherUser": function (newUrl) {
        ((((_vm.form || {}).data || {}).personnal || {}).profile_image || {}).value = newUrl;
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }